import React from "react";
import Column from "./Column";

interface TableHeaderProps extends React.HTMLAttributes<HTMLElement>{
  headersName: Array<string>
  columnswidth: Array<number>
  isGrouped?: boolean | undefined
  isDetail?: boolean | undefined
}

class TableHeader extends React.Component<TableHeaderProps> {
  render() {
    return (     
      <div className={this.props.className}>
        { (this.props.isGrouped ) &&
          <Column
            className={this.props.className + '-column'}
            columnname={"Selección"}
            columnwidth={50}
          />
        }
         {this.props.headersName?.map((name, columnIndex) =>
            <Column
              key={'c' + columnIndex}
              className={this.props.className + '-column'}
              columnname={(name) ? name : ' '}
              columnwidth={this.props.columnswidth[columnIndex]}
              data-testid={(this.props.isDetail? "col-detail-" : "columna-") + columnIndex}
              style={{ textAlign:"center"}}
            />
          )}
      </div>     
    );
  }
}

export default TableHeader;